import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";
import { Field } from "./common";
import { useSession } from "../lib/session";
import { INV_GROUPS } from "../lib/investigations";

export const InvestigationPanel = () => {
  const { state, set } = useSession();
  const inv = state.investigations || {};
  return (
    <div data-testid="investigation-panel">
      <h2 className="font-heading text-lg font-semibold mb-1">Investigation reports</h2>
      <p className="text-sm text-muted-foreground mb-4">Enter any available results. Leave pending tests blank.</p>
      <Accordion type="multiple" defaultValue={[INV_GROUPS[0][0]]} className="border rounded-md bg-card">
        {INV_GROUPS.map(([group, fields]) => {
          const filled = fields.filter(([k]) => inv[k]).length;
          return (
            <AccordionItem key={group} value={group} className="px-5">
              <AccordionTrigger data-testid={`inv-group-${group.split(" ")[0].toLowerCase()}`} className="font-heading text-base">
                <span>{group}{filled > 0 && <span className="cc-chip cc-chip-ok ml-2">{filled} entered</span>}</span>
              </AccordionTrigger>
              <AccordionContent className="pb-6">
                <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                  {fields.map(([k, lb, u]) => (
                    <Field key={k} id={`inv-${k}`} label={lb} unit={u} value={inv[k]} onChange={(x) => set("investigations", { ...inv, [k]: x })} />
                  ))}
                </div>
              </AccordionContent>
            </AccordionItem>
          );
        })}
      </Accordion>
    </div>
  );
};
